import React from "react";

import { useTranslation } from "react-i18next";

import BetSlipStore from "@state/bet-slip/BetSlipStore";
import { observer } from "mobx-react";

import BetSlipCurrentShareButton from "./BetSlipCurrentShareButton";

export default observer(function BetWidgetTabSelector(props: {
	store: BetSlipStore;
}) {
	const { t } = useTranslation();

	if (!WEBPACK_IS_BET_BUILDER_ENABLED) {
		return null;
	}

	return (
		<div className="slip__head">
			<div className="slip__head__title">
				{t<string>("BET_SLIP.TITLE")}
			</div>
			<BetSlipCurrentShareButton store={props.store} />
		</div>
	);
});
